import { render, staticRenderFns } from "./MediaCarousel.vue?vue&type=template&id=54f35dca&scoped=true&"
import script from "./MediaCarousel.vue?vue&type=script&lang=js&"
export * from "./MediaCarousel.vue?vue&type=script&lang=js&"
import style0 from "./MediaCarousel.vue?vue&type=style&index=0&id=54f35dca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f35dca",
  null
  
)

export default component.exports